/** Canonical public marketing homepage — avoids / → /mentor redirect hop. */
export const PUBLIC_MARKETING_HOME_PATH = "/start" as const;

export const getPublicLogoTarget = (options: {
  mode: "public" | "aramlas" | "account" | "standalone";
  isAdmin: boolean;
}): string => {
  if (options.mode === "aramlas") {
    return "/aramlas/home";
  }

  if (options.isAdmin) {
    return "/";
  }

  return PUBLIC_MARKETING_HOME_PATH;
};
